export default {
    ToggleDisplayLayer: 'toggle-display-layout',
    SelectDisplayBasemap: 'select-base-map',
    ClickProjectItem : 'click-project-item'
}